import { CalculatedDataResponse } from 'types';

export const calculatedDataInitialState: CalculatedDataResponse = {
    results: null,
};
